import React from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { PaginationContainer, PaginationButton, NavigationButton, EntriesContainer, PaginationInfo, StyledSelect, LeftSection } from "./CustomPagination.styled";
import { MenuItem, Box } from "@mui/material";

const CustomPagination = ({ table }) => {
  const {
    getState,
    setPageIndex,
    previousPage,
    nextPage,
    getCanPreviousPage,
    setPageSize,
  } = table;

  const { pagination } = getState();
  const { pageIndex, pageSize } = pagination;
  const totalRows = table.options.rowCount;
  const totalPages = Math.ceil(totalRows / pageSize);

  const startRecord = pageIndex * pageSize + 1;
  const endRecord = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <PaginationContainer>
      <LeftSection>
        <EntriesContainer>
          Show
          <StyledSelect
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            size="small"
          >
            <MenuItem value={15}>15</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={35}>35</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </StyledSelect>
          Entries
        </EntriesContainer>

        <PaginationInfo>
          Displaying {startRecord} through {endRecord} out of {totalRows} Records
        </PaginationInfo>
      </LeftSection>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <NavigationButton
          variant="outlined"
          onClick={() => previousPage()}
          disabled={!getCanPreviousPage()}
        >
          <ChevronLeft />
        </NavigationButton>

        {Array.from({ length: Math.min(3, totalPages) }).map((_, i) => {
          const pageNum = Math.max(0, pageIndex - 1) + i;

          if (pageNum < totalPages) {
            return (
              <PaginationButton
                key={pageNum}
                variant="outlined"
                onClick={() => setPageIndex(pageNum)}
                isActive={pageNum === pageIndex}
              >
                {pageNum + 1}
              </PaginationButton>
            );
          }
          return null;
        })}

        <NavigationButton
          variant="outlined"
          onClick={() => nextPage()}
          disabled={pageIndex >= totalPages - 1}
        >
          <ChevronRight />
        </NavigationButton>
      </Box>
    </PaginationContainer>
  );
};

export default CustomPagination;
